module.exports = __webpack_public_path__ + "static/media/alignment_input_data.f091a1ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/info/alignment_input_data.png
// module id = 2350
// module chunks = 0